import getDirectusInstance from '#lib/directus/directus.js';
import { readItems } from '@directus/sdk';
import { error } from '@sveltejs/kit';

export const load = async ({ fetch, params, url }) => {
	const directus = getDirectusInstance(fetch);
	const prefix = params.wildcats ? params.wildcats + '/' : '';

	const page = (
		await directus.request(
			readItems('page', {
				filter: {
					status: url.searchParams.has('preview')
						? { _in: ['published', 'draft'] }
						: { _in: ['published'] },
					slug: { _eq: prefix + params.slug }
				},
				fields: ['*', 'blocks.*.*.*']
			})
		)
	)[0];

	if (!page) {
		error(404, 'Seite nicht gefunden');
	}

	return {
		page
	};
};
